import { HideFor, InfoSmallIcon, LabeledTags, Picture } from "/App.Components";
import "./ListSearchPublicationArticleItem.scss";
import { ListSearchPublicationArticleItemProps } from "/App.GeneratedTypes";
import { LinkTargetType, TagsColors } from "/App.GeneratedEnums";
import { createSpreadableBem } from "/Helpers/createBem";

const ListSearchPublicationArticleItem: React.FC<
  ListSearchPublicationArticleItemProps
> = ({
  link,
  image,
  heading,
  label,
  linkType,
  areas,
  areasLabel,
  themes,
  themesLabel,
}) => {
  const bem = createSpreadableBem("list-search-publication-article-item");
  let ariaLabel = `${heading} `;
  if ((areas?.length ?? 0) > 0)
    ariaLabel += `${areasLabel} ${areas?.join(", ")} `;
  if ((themes?.length ?? 0) > 0)
    ariaLabel += `${themesLabel} ${themes?.join(", ")} `;
  if (image?.altText) ariaLabel += image.altText + " ";
  const hasThemes = (themes?.length ?? 0) > 0;
  const hasAreas = (areas?.length ?? 0) > 0;
  return (
    <section {...bem("")}>
      <a
        href={link}
        target={linkType === LinkTargetType.External ? "_blank" : "_self"}
        aria-label={ariaLabel}
      >
        <div {...bem("__container")}>
          <div {...bem("__text")}>
            {label && (
              <div {...bem("__label")}>
                <InfoSmallIcon text={label} theme="insightBlue" />
              </div>
            )}
            {heading && (
              <h3 {...bem("__heading")}>
                <span {...bem("__span")}>{heading}</span>
              </h3>
            )}
            {(hasThemes || hasAreas) && (
              <div {...bem("__categories-container")}>
                <LabeledTags
                  label={themesLabel}
                  categoryTags={themes}
                  color={TagsColors.Insight}
                />
                <LabeledTags
                  label={areasLabel}
                  categoryTags={areas}
                  color={TagsColors.Insight}
                />
              </div>
            )}
          </div>
          {image && (
            <HideFor mobile tablet>
              <Picture {...image} noAlt />
            </HideFor>
          )}
        </div>
      </a>
    </section>
  );
};

export default ListSearchPublicationArticleItem;
